module.exports = __webpack_public_path__ + "static/media/Smartapi-Logo-1200x212-Transparent.ef58ca94.png";